import { AHQueryHandlerError, AHQueryHandlerLoading } from "arkh";
import cuid from "cuid";
import React, { ReactNode, Suspense, useRef } from "react";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import { useNewFetchKeyOnNav } from "../../useNewFetchKeyOnNav";
import { captureException } from "../../common/sentry";

export function ErrorFallback({
  resetErrorBoundary,
}: {
  error: Error;
  resetErrorBoundary: () => void;
}) {
  return <AHQueryHandlerError isLoading={false} onPress={resetErrorBoundary} />;
}

let i = 0;
function NetworkBoundraryC(props: {
  newFetchKeyOnNavigation?: boolean;
  fetchKey?: string | number;
  children: (fetchKey: string) => ReactNode | undefined;
  fallback?: ReactNode;
  errorFallback?: React.ComponentType<FallbackProps>;
}) {
  const ref = useRef(cuid());
  const [fetchKey, setFetchKey] = React.useState(i);
  const fk = useNewFetchKeyOnNav();

  const key =
    fetchKey.toString() +
    (props.fetchKey ?? "") +
    ref.current +
    (props.newFetchKeyOnNavigation ? fk : "");
  return (
    <ErrorBoundary
      onReset={() => {
        i = (i + 1) % Number.MAX_SAFE_INTEGER;
        setFetchKey(i);
      }}
      onError={(e, info) => {
        captureException(e, { extra: { info } });
      }}
      FallbackComponent={props.errorFallback ?? ErrorFallback}
    >
      <Suspense
        key={fetchKey}
        fallback={props.fallback ?? <AHQueryHandlerLoading />}
      >
        {props.children(key)}
      </Suspense>
    </ErrorBoundary>
  );
}

export const LazyQueryNetworkBoundrary = React.memo(NetworkBoundraryC);
